import * as React from "react";
import { Layout as ReactAdminLayout } from 'react-admin';
import { AppBar } from './AppBar';

export const Layout = (props: any) => <ReactAdminLayout {...props} appBar={AppBar} />;
